// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Cookies_fadeIn__5EGpX"};